import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectLanguage } from '../redux/cartSlice';
import { translations } from '../utils/translations';
import './UserProfile.css';

const UserProfile = () => {
  const selectedLang = useSelector(selectLanguage) || { code: 'en' };
  const t = translations[selectedLang.code || 'en'] || translations.en;
  
  const [user, setUser] = useState(null);

  useEffect(() => {
    const session = localStorage.getItem('user_session');
    if (session) {
      setUser(JSON.parse(session));
    } else {
      // Redirect to login if no session is active
      window.history.pushState({}, '', '/login');
      window.dispatchEvent(new PopStateEvent('popstate'));
    }
  }, []);

  const handleSignOut = () => {
    localStorage.removeItem('user_session');
    setUser(null);
    window.dispatchEvent(new Event('auth_change'));
    
    import('sweetalert2').then((Swal) => {
      Swal.default.fire({
        title: selectedLang.code === 'el' ? 'Αποσυνδεθήκατε' : (selectedLang.code === 'nl' ? 'Uitgelogd' : 'Signed Out'),
        text: selectedLang.code === 'el' ? 'Αποσυνδεθήκατε επιτυχώς.' : (selectedLang.code === 'nl' ? 'U bent succesvol uitgelogd.' : 'You have been logged out successfully.'),
        icon: 'success',
        timer: 1500,
        showConfirmButton: false
      });
    });

    window.history.pushState({}, '', '/');
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  if (!user) {
    return (
      <div className="profile-loading-wrapper">
        <div className="modern-loading-screen">
          <div className="loader-orbit">
            <div className="orbit-item"></div>
            <div className="orbit-item"></div>
          </div>
        </div>
      </div>
    );
  }

  // Get initials for profile badge
  const getInitials = (name) => {
    if (!name) return 'U';
    return name
      .split(' ')
      .map((n) => n[0])
      .slice(0, 2)
      .join('')
      .toUpperCase();
  };

  const getProfileTitle = () => {
    switch (selectedLang.code) {
      case 'nl': return 'Mijn Profiel';
      case 'el': return 'Το Προφίλ μου';
      case 'es': return 'Mi Perfil';
      case 'fr': return 'Mon Profil';
      case 'de': return 'Mein Profil';
      case 'it': return 'Il Mio Profilo';
      case 'pt': return 'Meu Perfil';
      default: return 'My Profile';
    }
  };

  const getRoleLabel = () => {
    if (user.isB2B) {
      switch (selectedLang.code) {
        case 'nl': return 'B2B Partner';
        case 'el': return 'B2B Συνεργάτης';
        default: return 'B2B Partner';
      }
    }
    switch (selectedLang.code) {
      case 'nl': return 'Klant';
      case 'el': return 'Πελάτης';
      default: return 'Retail Customer';
    }
  };

  return (
    <div className="profile-page-wrapper">
      <div className="profile-card-container animate-fade-in">
        <div className="profile-header-banner">
          <div className="profile-avatar-circle">
            {getInitials(user.fullName)}
          </div>
        </div>
        
        <div className="profile-card-content">
          <h2 className="profile-title">{getProfileTitle()}</h2>
          <span className="profile-role-badge">{getRoleLabel()}</span>

          <div className="profile-fields-list">
            <div className="profile-field-row">
              <span className="field-label">{t.fullName || 'Full Name'}</span>
              <span className="field-value">{user.fullName}</span>
            </div>
            
            <div className="profile-field-row">
              <span className="field-label">{t.emailAddress || 'Email Address'}</span>
              <span className="field-value">{user.email}</span>
            </div>
          </div>

          <button className="btn-profile-signout" onClick={handleSignOut}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px' }}>
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" />
            </svg>
            {t.signOut || 'Sign Out'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
